/// <reference path="../typings/index.d.ts" />
/// <reference path="AutoDme.d.ts" />

namespace App {
  export class AutoDme implements IAutoDme {
    private idExtensao: string = null;
    private exibirLog: any = null;
    private categoriaDmes: ICategoriaDme[] = [];
    private dmeIdInicial: number = 1;
    private dmeAtual: number = null;
    // defaults do DME inicial
    private readonly INITIAL_DEFAULT_CONFIG: Record<string, any> = {
      repetir: 0,
      repetirIntervaloMinutos: 1,
      tipoSugestaoSolucao: 1,
      quantidadeSolucoesColetadas: 0,
      excluirNegociaveis: true,
      excluirEspeciais: true,
      usarConceitos: true,
      coletarConceitos: true,
      quantidadeMaximaDeJogConceitos: 0,
      minimoRating: 45,
      maximoRating: 70,
      tempoMaximoResolucaoMinutos: 100,
      usarDuplicatas: true,
      abrirPacksInegociaveisAutomaticamente: true,
      enviarAutomaticamente: true,
      precoMaximoDesafio: 20000,
      precoMaximoJogador: 200,
      naoUsarJogadorCaroNegociavel: 10000,
      naoUsarJogadorCaroInegociavel: 20000,
      comprarJogadorSomenteNaCertezaDeSolucao: true,
      retentativasAntesDeFecharWebApp: 0,
      forcarSolucaoACadaRetentativa: false,
      aumentarRatingAposCadaTentativa: 0,
      aumentarPrecoJogadorAposCadaTentativa: 0,
      enviarImediatamenteSeEstiverPronto: true,
      solucaoRapida: false
    };

    // Elementos via jQuery
    private elModoDme: JQuery = $('#modoDme');
    private elSelectCategory: JQuery = $('#select-category');
    private elSelectDme: JQuery = $('#select-dme');
    private elTitle: JQuery = $('#dme-title');
    private elSubtitle: JQuery = $('#dme-subtitle');
    private elRepeatable: JQuery = $('#dme-repeatable');
    private elRemaining: JQuery = $('#dme-remaining');
    private elCost: JQuery = $('#dme-cost');
    private elImg: JQuery = $('#dme-image');
    private elStatus: JQuery = $('#resolver-status');
    private elBtnResolver: JQuery = $('#btn-resolver');
    private elBtnCancelarSolucao: JQuery = $('#btn-cancelar-solucao');
    private elBtnScanearClube: JQuery = $('.botao-escanear-itens-clube-auto-dme');
    private elChkSolucaoRapida: JQuery = $('#solucaoRapida');

    // ------------ Persistência ------------
    private storageNS = 'autoDme:v1';
    private persistentFieldIds: string[] = [
      // números
      'repetir', 'repetirIntervaloMinutos', 'tipoSugestaoSolucao', 'quantidadeSolucoesColetadas',
      'quantidadeMaximaDeJogConceitos', 'minimoRating', 'maximoRating', 'tempoMaximoResolucaoMinutos',
      'precoMaximoDesafio', 'precoMaximoJogador', 'naoUsarJogadorCaroNegociavel', 'naoUsarJogadorCaroInegociavel',
      'retentativasAntesDeFecharWebApp', 'aumentarRatingAposCadaTentativa', 'aumentarPrecoJogadorAposCadaTentativa',
      // checkboxes
      'excluirNegociaveis', 'excluirEspeciais', 'usarConceitos', 'coletarConceitos',
      'usarDuplicatas', 'abrirPacksInegociaveisAutomaticamente', 'enviarAutomaticamente',
      'comprarJogadorSomenteNaCertezaDeSolucao', 'forcarSolucaoACadaRetentativa',
      'enviarImediatamenteSeEstiverPronto',
      'solucaoRapida'
    ];
    // ids que devem ser desabilitados quando solucaoRapida = true
    private readonly fastSolutionDisableIds: string[] = [
      'tipoSugestaoSolucao',
      'quantidadeSolucoesColetadas',
      'minimoRating',
      'maximoRating',
      'quantidadeMaximaDeJogConceitos'
    ];

    constructor(idExtensao: string, exibirLog: any) {
      this.idExtensao = idExtensao;
      this.exibirLog = exibirLog;
      console.log('AutoDme iniciado', this.idExtensao);

      // carrega categorias da blade (data-attr) ou de window
      const categorias = this.elModoDme.data('categoriasDmes') || (window as any).CATEGORIES;
      this.categoriaDmes = typeof categorias === 'string' ? (JSON.parse(categorias) || []) : (categorias || []);

      this.bindUI();
      // Preenche selects — se estiver vazio, tentamos recuperar do storage aqui dentro
      this.populateCategorySelect();

      // Restaura padrões globais e liga listeners de persistência
      this.restoreGlobalDefaults();
      this.enablePersistenceListeners();

      this.setupNumericValidation();

      (window as any).autoDme = this;
    }

    // =======================
    //         AÇÕES
    // =======================
    public resolver(): ResolverPayload | null {
      App.SniperExtensao.exibirLoadingSniperApp('<i class="fas " style="font-size: 34px;" title="Resolvendo aguarde...">🕔</i>', false, "Resolvendo aguarde...");
      const payload = this.buildPayload();
      console.log('Payload para resolver:', payload);
      if (!payload) return null;

      // Salva config global e por DME selecionado
      const dmeIdToSave = String(this.elSelectDme.val() || '');
      this.saveCurrentConfigToStorage('global');
      if (dmeIdToSave) this.saveCurrentConfigToStorage(this.scopeKeyForDme(dmeIdToSave));

      this.setStatus('Configuração gerada.', true);
      this.solucionarDmeNoWebApp(payload);
      return payload;
    }

    // =======================
    //      UI / DOM Binds
    // =======================
    private bindUI(): void {
      //toDo boato scanear escondido por enquanto
      this.elBtnScanearClube.hide();

      if (this.elSelectCategory.length) this.elSelectCategory.on('change', () => this.onCategoryChanged());
      if (this.elSelectDme.length) this.elSelectDme.on('change', () => this.onDmeSelected());
      if (this.elBtnResolver.length) this.elBtnResolver.on('click', () => this.resolver());
      if (this.elBtnCancelarSolucao.length) this.elBtnCancelarSolucao.on('click', () => this.cancelarSolucao());
      if (this.elBtnScanearClube.length) this.elBtnScanearClube.on('click', () => this.scanearClube());
      if (this.elChkSolucaoRapida.length) { this.elChkSolucaoRapida.on('change', () => this.applyFastSolutionUi()) }
      // Chame isso no evento de blur/change dos inputs:
      $('#espacoCamposLinksDme').on('change', 'input[id^="linkFutbin"]', () => {
        this.salvarLinksFutbin();
      });
    }

    // ---------- salva/recupera último categories (DMEs) ----------
    private readLastDmes(): ICategoriaDme[] {
      try {
        const raw = localStorage.getItem(`${this.storageNS}:lastDmes`);
        const obj = raw ? JSON.parse(raw) : null;
        // compat: pode ter sido salvo { categories: [...] } ou diretamente [...]
        if (obj && Array.isArray(obj)) return obj as ICategoriaDme[];
        if (obj && Array.isArray(obj.categories)) return obj.categories as ICategoriaDme[];
        return [];
      } catch { return []; }
    }

    private writeLastDmes(cats: ICategoriaDme[] | { categories: ICategoriaDme[] }): void {
      try {
        const toSave = Array.isArray(cats) ? cats : (cats && cats.categories ? cats.categories : []);
        localStorage.setItem(`${this.storageNS}:lastDmes`, JSON.stringify(toSave));
      } catch { /* ignore */ }
    }

    // ---------- restauração de última seleção (categoria/dme) ----------
    private getLastSelection(): { categoryId?: string; setId?: string } {
      try {
        const raw = localStorage.getItem(`${this.storageNS}:lastSelection`);
        return raw ? JSON.parse(raw) : {};
      } catch { return {}; }
    }

    private setLastSelection(sel: { categoryId?: string; setId?: string }) {
      const prev = this.getLastSelection();
      localStorage.setItem(
        `${this.storageNS}:lastSelection`,
        JSON.stringify({ ...prev, ...sel })
      );
    }

    // ---------- selects ----------
    private populateCategorySelect(): void {
      if (!this.elSelectCategory.length) return;

      // Se não há dados carregados, tenta usar o último salvo
      if (!this.categoriaDmes || this.categoriaDmes.length === 0) {
        const cached = this.readLastDmes();
        if (cached && cached.length > 0) {
          console.log('Restaurando categorias/DMEs do storage (lastDmes).');
          this.categoriaDmes = cached;
        }
      }

      // limpa mantendo placeholder
      this.elSelectCategory.find('option:not(:first)').remove();

      // Verifica se existe o DME inicial disponível em alguma categoria
      const categoriaDoInicial = (this.categoriaDmes || []).find(cat =>
        Array.isArray(cat.sets) &&
        cat.sets.some(s => String(s.setId) === String(this.dmeIdInicial) && !s.timesCompleted)
      );

      const categoriasParaMostrar = categoriaDoInicial ? [categoriaDoInicial] : (this.categoriaDmes || []);

      // popula apenas as categorias permitidas
      categoriasParaMostrar.forEach((cat: ICategoriaDme) => {
        const $opt = $('<option/>', {
          value: String(cat.categoryId),
          text: cat.name
        }).attr('data-name', cat.name);
        this.elSelectCategory.append($opt);
      });

      // tenta restaurar seleção anterior (categoria + dme)
      const { categoryId, setId } = this.getLastSelection();

      if (categoryId && this.elSelectCategory.find(`option[value="${categoryId}"]`).length) {
        // seta categoria sem disparar change automaticamente
        this.elSelectCategory.val(categoryId);

        const catIdNum = parseInt(String(categoryId), 10);
        this.populateDmeSelect(Number.isFinite(catIdNum) ? catIdNum : null);

        // tenta restaurar DME
        if (setId && this.elSelectDme.find(`option[value="${setId}"]`).length) {
          this.elSelectDme.val(setId);
          // atualiza header e restaura config por DME
          this.onDmeSelected();
        } else {
          this.clearHeader();
        }
      } else {
        // sem restauração válida
        this.clearHeader();
        this.elSelectDme.prop('disabled', true).val('');
      }
    }

    private onCategoryChanged(): void {
      const catId = this.getSelectedCategoryId();
      console.log('Categoria selecionada:', catId, this.categoriaDmes);

      // salva categoria e limpa setId anterior
      this.setLastSelection({ categoryId: catId != null ? String(catId) : '', setId: '' });

      this.clearHeader();
      this.populateDmeSelect(catId);
    }

    private populateDmeSelect(categoryId: number | null): void {
      if (!this.elSelectDme.length) return;

      this.elSelectDme.prop('disabled', true);
      this.elSelectDme.find('option:not(:first)').remove();
      if (categoryId == null) return;

      const cat = this.categoriaDmes.find((c: any) => Number(c.categoryId) === Number(categoryId));
      if (!cat || !Array.isArray(cat.sets)) return;

      // Base: só DMEs não concluídos
      const setsElegiveis = cat.sets.filter((s: any) => !s.timesCompleted || (s.repeatable && s.timesCompleted));

      // Regra 2: se o DME inicial está na lista, SOMENTE ele pode ser selecionado
      const temDmeInicial = setsElegiveis.some((s: any) => String(s.setId) === String(this.dmeIdInicial));
      const listaFinal = temDmeInicial
        ? setsElegiveis.filter((s: any) => String(s.setId) === String(this.dmeIdInicial))
        : setsElegiveis;

      listaFinal.forEach((set: any) => {
        const $opt = $('<option/>', {
          value: String(set.setId),
          text: set.name
        })
          .attr('data-name', set.name)
          .attr('data-image', this.buildSetImageUrl(set.setId))
          .attr('data-repeatable', set.repeatable ? 'Repeatable' : 'Non-Repeatable')
          .attr('data-remaining', this.humanizeRemaining(set.endTime))
          .attr('data-cost', '—');
        this.elSelectDme.append($opt);
      });

      this.elSelectDme.prop('disabled', false);

      // Se o inicial existe, já força seleção nele e atualiza UI/config.
      if (temDmeInicial) {
        this.elSelectDme.val(String(this.dmeIdInicial));
        // salva seleção e atualiza header/config de DME inicial
        this.setLastSelection({ setId: String(this.dmeIdInicial) });
        this.onDmeSelected(); // isso já chama applyInitialDmeUi(true) e aplica defaults do inicial
      }
    }

    private getSelectedCategoryId(): number | null {
      const v = this.elSelectCategory.val();
      if (v == null || v === '') return null;
      const n = parseInt(String(v), 10);
      return Number.isFinite(n) ? n : null;
    }

    private buildSetImageUrl(setId: string | null): string {
      if (!setId) return '';
      return `https://cdn.futnext.com/sbc/set/${setId}.png`;
    }

    private humanizeRemaining(endTime: number | null): string {
      if (!endTime || endTime <= 0) return '—';
      // Se endTime for "segundos restantes"
      const mins = Math.floor(endTime / 60);
      const days = Math.floor(mins / (60 * 24));
      const remMins = mins % (60 * 24);
      const hours = Math.floor(remMins / 60);
      const minutes = remMins % 60;
      const parts: string[] = [];
      if (days) parts.push(`${days}d`);
      if (hours) parts.push(`${hours}h`);
      if (minutes) parts.push(`${minutes}m`);
      return parts.length ? parts.join(' ') : `${mins}m`;
    }

    private salvarLinksFutbin(): void {
      const links = App.Util.obterLinksFutbin();
      localStorage.setItem('linksFutbin', JSON.stringify(links));
    }

    private limparLinksFutbin(): void {
      // Limpa os campos de input
      const container = document.getElementById('espacoCamposLinksDme');
      if (container) {
        const inputs: any = container.querySelectorAll('input[id^="linkFutbin"]');
        inputs.forEach((input: any) => {
          (input as HTMLInputElement).value = '';
        });
      }
      // Limpa o localStorage
      localStorage.removeItem('linksFutbin');
    }

    private onDmeSelected(): void {
      const $opt = this.elSelectDme.find('option:selected');
      const dmeId = this.elSelectDme.val();

      if (!$opt.length || !dmeId) {
        this.clearHeader();
        // limpa setId mantendo categoryId
        this.setLastSelection({ setId: '' });
        return;
      }

      if (this.dmeAtual && this.dmeAtual != dmeId) {
        this.limparLinksFutbin();
      }

      this.dmeAtual = dmeId

      // Hard-guard adicional: se o inicial está na lista, força seleção nele
      const existeInicialNoSelect = this.elSelectDme.find(`option[value="${this.dmeIdInicial}"]`).length > 0;
      if (existeInicialNoSelect && String(dmeId) !== String(this.dmeIdInicial)) {
        this.elSelectDme.val(String(this.dmeIdInicial));
      }

      // salva setId atual
      const currentVal = String(this.elSelectDme.val() || '');
      this.setLastSelection({ setId: currentVal });

      // procura o objeto inteiro no array de categorias/sets
      const dmeObj = (this.categoriaDmes as any)
        .flatMap((cat: ICategoriaDme) => cat.sets)
        .find((set: IConjuntoDme) => String(set.setId) === String(currentVal));

      console.log('DME selecionado (objeto completo):', dmeObj);

      // limpe a div#espacoCamposLinksDme e crie campos de links para o Futbin de acordo com dmeObj.challengesCount
      // se dmeObj.challengesCount for 0 ou nulo, não cria nada, se existir cria a quantidade de campos input de acordo dmeObj.challengesCount
      const $linksContainer = $('#espacoCamposLinksDme');
      $linksContainer.empty();

      let savedLinks = this.getSavedLinksFutbin();

      let sbcLinkUnico: boolean = dmeObj.challengesCount <= 1;
      if (dmeObj && dmeObj.challengesCount && dmeObj.challengesCount > 0) {
        for (let i = (sbcLinkUnico ? 0 : 1); i <= (sbcLinkUnico ? dmeObj.challengesCount - 1 : dmeObj.challengesCount); i++) {
          const $group = $('<div/>', { class: 'form-group mb-2' });
          const $label = $('<label/>', { for: `linkFutbin${i}`, class: "form-control-label", text: `Link Futbin Desafio ${i}` });
          const $input = $('<input/>', {
            type: 'text',
            class: 'form-control',
            id: `linkFutbin${i}`,
            name: `link_desafio_futbin_${i}`,
            placeholder: `Link do Futbin para o desafio ${i}`,
            value: savedLinks[i] || ''
          });
          $group.append($label).append($input);
          $linksContainer.append($group);
        }
      }

      this.abrirColapseLinkSeExistirCampoLinkPreenchido()

      if (!dmeObj) {
        this.clearHeader();
        return;
      }

      // Atualiza header com dados do objeto
      this.setText(this.elTitle, dmeObj.name);
      this.setText(this.elSubtitle, '');
      this.setText(this.elRepeatable, dmeObj.repeatable ? 'Repeatable' : 'Non-Repeatable');
      this.setText(this.elRemaining, this.humanizeRemaining(dmeObj.endTime));
      this.setText(this.elCost, '—');

      // usa setImageId para montar a URL correta
      if (this.elImg.length) {
        const imgUrl = this.buildSetImageUrl(dmeObj.setId || null);
        if (imgUrl) this.elImg.attr('src', imgUrl).removeClass('d-none');
        else this.elImg.addClass('d-none').removeAttr('src');
      }

      const selectedId = String(dmeObj.setId);
      const ehDmeInicial = String(selectedId) === String(this.dmeIdInicial);
      if (ehDmeInicial) {
        this.applyInitialDefaultsForDme(selectedId, /* persist */ true);
        this.applyInitialDmeUi(true);
      } else {
        this.applySavedConfigForScope(this.scopeKeyForDme(selectedId));
        this.applyInitialDmeUi(false);
        this.applyFastSolutionUi();
      }
    }

    private getSavedLinksFutbin() {
      let savedLinks: { [key: number]: string } = {};
      try {
        savedLinks = JSON.parse(localStorage.getItem('linksFutbin') || '{}');
      } catch { }

      return savedLinks
    }

    private abrirColapseLinkSeExistirCampoLinkPreenchido(): void {
      let savedLinks = this.getSavedLinksFutbin();
      // caso exista links salvos clica em #headingOneAddLink collapsa show se estive hide
      const hasLinksPreenchidos: any = (Object as any).values(savedLinks).some((v: any) => v && v.trim() !== '');
      if (hasLinksPreenchidos && !$('#addLinksDesafios').hasClass('show')) {
        $('#headingOneAddLink button').trigger('click');
      }
    }
    private applyInitialDmeUi(isInitial: boolean): void {
      const $configWrapper = $('#config-dme');
      const $all = $configWrapper.find('input, select, textarea');
      const $keep = $('#excluirNegociaveis, #abrirPacksInegociaveisAutomaticamente');

      if (isInitial) {
        $all.not($keep).prop('disabled', true)
          .closest('.form-group, .d-flex, .col').css('opacity', 0.3);
        $keep.prop('disabled', false)
          .closest('.form-group, .d-flex, .col').css('opacity', 1);

      } else {
        $all.prop('disabled', false)
          .closest('.form-group, .d-flex, .col').css('opacity', 1);
      }
    }



    private buildPayload(): ResolverPayload | null {
      const $opt = this.elSelectDme.find('option:selected');
      const val = this.elSelectDme.val();
      if (!$opt.length || val == null || val === '') {
        this.setStatus('Selecione um DME antes de resolver.', false);
        return null;
      }

      const linksObj = App.Util.obterLinksFutbin();
      const links = Object.keys(linksObj).length === 0 ? null : linksObj;

      if (Object.keys(linksObj).length == 1) {
        links[parseInt(val)] = links[1];
        links[225] = links[1];
      }

      // uso:
      const dme: DmePayload = {
        setId: this.parseIntSafe(String(val)),
        name: $opt.attr('data-name') || null,
        links: links,
      };

      const cfg: ConfiguracaoPayload = {
        repetir: this.num('repetir'),
        repetirIntervaloMinutos: this.num('repetirIntervaloMinutos'),
        tipoSugestaoSolucao: this.num('tipoSugestaoSolucao'),
        quantidadeSolucoesColetadas: this.num('quantidadeSolucoesColetadas'),

        excluirNegociaveis: this.bool('excluirNegociaveis'),
        excluirEspeciais: this.bool('excluirEspeciais'),

        usarConceitos: this.bool('usarConceitos'),
        coletarConceitos: this.bool('coletarConceitos'),
        quantidadeMaximaDeJogConceitos: this.num('quantidadeMaximaDeJogConceitos'),

        minimoRating: this.num('minimoRating'),
        maximoRating: this.num('maximoRating'),
        tempoMaximoResolucaoMinutos: this.num('tempoMaximoResolucaoMinutos'),

        usarDuplicatas: this.bool('usarDuplicatas'),
        abrirPacksInegociaveisAutomaticamente: this.bool('abrirPacksInegociaveisAutomaticamente'),
        abrirPacksNegociaveisAutomaticamente: false,
        enviarAutomaticamente: this.bool('enviarAutomaticamente'),

        precoMaximoDesafio: this.num('precoMaximoDesafio'),
        precoMaximoJogador: this.num('precoMaximoJogador'),
        naoUsarJogadorCaroNegociavel: this.num('naoUsarJogadorCaroNegociavel'),
        naoUsarJogadorCaroInegociavel: this.num('naoUsarJogadorCaroInegociavel'),

        comprarJogadorSomenteNaCertezaDeSolucao: this.bool('comprarJogadorSomenteNaCertezaDeSolucao'),
        retentativasAntesDeFecharWebApp: this.num('retentativasAntesDeFecharWebApp'),
        forcarSolucaoACadaRetentativa: this.bool('forcarSolucaoACadaRetentativa'),
        aumentarRatingAposCadaTentativa: this.num('aumentarRatingAposCadaTentativa'),
        aumentarPrecoJogadorAposCadaTentativa: this.num('aumentarPrecoJogadorAposCadaTentativa'),

        enviarImediatamenteSeEstiverPronto: this.bool('enviarImediatamenteSeEstiverPronto'),
        solucaoRapida: this.bool('solucaoRapida')
      };

      return { dme, configuracao: cfg };
    }

    private clearHeader(): void {
      this.setText(this.elTitle, '');
      this.setText(this.elSubtitle, '');
      this.setText(this.elRepeatable, '—');
      this.setText(this.elRemaining, '—');
      this.setText(this.elCost, '—');
      if (this.elImg.length) {
        this.elImg.addClass('d-none').removeAttr('src');
      }
    }

    private setText($el: JQuery, text: string): void {
      if ($el && $el.length) $el.text(text);
    }

    private setStatus(msg: string, ok: boolean): void {
      if (!this.elStatus.length) return;
      this.elStatus
        .text(msg)
        .removeClass('text-red-600 text-green-600')
        .addClass(ok ? 'text-green-600' : 'text-red-600');
    }

    private num(id: string): number {
      const $el = $('#' + id);
      if (!$el.length) return 0;
      const value = $el.val();
      const v = parseInt(value !== undefined && value !== null ? String(value) : '', 10);
      return Number.isFinite(v) ? v : 0;
    }

    private bool(id: string): boolean {
      const $el = $('#' + id);
      return !!($el.length && ($el.prop('checked') === true));
    }

    private parseIntSafe(v: string): number {
      const n = parseInt(v, 10);
      return Number.isFinite(n) ? n : 0;
    }

    private async postConfig(url: string, payload: ResolverPayload): Promise<Response> {
      const tokenConteudo = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement);
      const token = tokenConteudo ? tokenConteudo.content : '';
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': token
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin',
      });
    }

    // =======================
    //   Persistência Helpers
    // =======================
    private scopeKeyForDme(dmeId: string): string {
      return `dme:${dmeId}`;
    }

    private readScope(scope: 'global' | string): Record<string, any> {
      const key = `${this.storageNS}:${scope}`;
      try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    }

    private writeScope(scope: 'global' | string, patch: Record<string, any>): void {
      const key = `${this.storageNS}:${scope}`;
      const prev = this.readScope(scope);
      const next = { ...prev, ...patch };
      localStorage.setItem(key, JSON.stringify(next));
    }

    private applySavedConfigForScope(scope: 'global' | string): void {
      const data = this.readScope(scope);
      this.persistentFieldIds.forEach(id => {
        const $el = $('#' + id);
        if (!$el.length) return;
        const val = data[id];
        if (val === undefined) return;

        const tag = ($el.prop('tagName') || '').toString().toLowerCase();
        const type = ($el.attr('type') || '').toLowerCase();

        if (type === 'checkbox') {
          $el.prop('checked', !!val);
        } else if (tag === 'select' || type === 'number' || type === 'text') {
          $el.val(val);
        }
      });
    }

    private restoreGlobalDefaults(): void {
      this.applySavedConfigForScope('global');

      // Só aplica a UI de solução rápida se o DME atual NÃO é o inicial
      const currentDmeId = String(this.elSelectDme.val() || '');
      if (!currentDmeId || String(currentDmeId) !== String(this.dmeIdInicial)) {
        this.applyFastSolutionUi();
      }
    }

    private applyFastSolutionUi(): void {
      // Se o DME atual é o inicial, NÃO desabilita/habilita nada
      const currentDmeId = String(this.elSelectDme.val() || '');
      if (currentDmeId && String(currentDmeId) === String(this.dmeIdInicial)) {
        return;
      }

      const fast = this.bool('solucaoRapida'); // true = desabilitar campos
      this.fastSolutionDisableIds.forEach(id => {
        const $el = $('#' + id);
        if ($el.length) {
          $el.prop('disabled', fast);
          // deixa visualmente opaco o bloco do campo (opcional)
          const $wrap = $el.closest('.form-group, .d-flex, .col');
          $wrap.css('opacity', fast ? 0.3 : 1);
        }
      });

      // persiste escolha global + por-DME (se houver)
      this.writeScope('global', { solucaoRapida: fast });
      const dmeId = String(this.elSelectDme.val() || '');
      if (dmeId) {
        this.writeScope(this.scopeKeyForDme(dmeId), { solucaoRapida: fast });
      }

      if (fast) {
        $('#menuLinksFutbin').show();
      } else {
        $('#menuLinksFutbin').hide();
        this.limparLinksFutbin();
        if ($('#addLinksDesafios').hasClass('show')) {
          $('#headingOneAddLink button').trigger('click');
        }
      }
    }

    private persistFieldChange(fieldId: string): void {
      const $el = $('#' + fieldId);
      if (!$el.length) return;

      let value: any;
      const tag = ($el.prop('tagName') || '').toString().toLowerCase();
      const type = ($el.attr('type') || '').toLowerCase();

      if (type === 'checkbox') {
        value = $el.prop('checked') === true;
      } else {
        value = $el.val();
      }

      // global
      this.writeScope('global', { [fieldId]: value });

      // por DME (se houver um selecionado)
      const dmeId = String(this.elSelectDme.val() || '');
      if (dmeId) {
        this.writeScope(this.scopeKeyForDme(dmeId), { [fieldId]: value });
      }
    }

    private enablePersistenceListeners(): void {
      this.persistentFieldIds.forEach(id => {
        const $el = $('#' + id);
        if (!$el.length) return;
        $el.on('change', () => this.persistFieldChange(id));
        // // Se quiser salvar enquanto digita:
        // $el.on('input',  () => this.persistFieldChange(id));
      });
    }

    private saveCurrentConfigToStorage(scope: 'global' | string): void {
      const patch: Record<string, any> = {};
      this.persistentFieldIds.forEach(id => {
        const $el = $('#' + id);
        if (!$el.length) return;
        const type = ($el.attr('type') || '').toLowerCase();
        patch[id] = type === 'checkbox' ? ($el.prop('checked') === true) : $el.val();
      });
      this.writeScope(scope, patch);
    }

    private resetarCategoriasDmes(): void {
      this.setLastSelection({ categoryId: '', setId: '' });
      this.elSelectCategory.val('');
      this.elSelectDme.prop('disabled', true).val('');
      this.clearHeader();
    }

    private solucionarDmeNoWebApp(payload?: ResolverPayload): void {
      try {
        console.log('Enviando mensagem para extensão do Chrome para resolver o DME...', payload, this.idExtensao);
        chrome.runtime.sendMessage(this.idExtensao, { evento: "rsolvdme", request: payload }, (_resultado: any) => { });
      } catch (e) {
        console.error('Falha ao enviar mensagem à extensão:', e);
      }
    }

    /** Aplica um objeto de config aos inputs do formulário */
    private applyConfigToForm(config: Record<string, any>): void {
      Object.keys(config).forEach((fieldId) => {
        const $el = $('#' + fieldId);
        if (!$el.length) return;

        const type = ($el.attr('type') || '').toLowerCase();
        if (type === 'checkbox') {
          $el.prop('checked', !!config[fieldId]);
        } else {
          $el.val(config[fieldId]);
        }
        // dispare change para quem estiver ouvindo
        $el.trigger('change');
      });
    }

    /** Aplica os defaults para o DME inicial e (opcional) persiste no storage por-DME */
    private applyInitialDefaultsForDme(dmeId: string, persist = true): void {
      // 1) aplica nos campos
      this.applyConfigToForm(this.INITIAL_DEFAULT_CONFIG);

      // 2) persiste no storage desse DME (para reabrir com os mesmos valores)
      if (persist) {
        const scope = this.scopeKeyForDme(dmeId);
        this.writeScope(scope, { ...this.INITIAL_DEFAULT_CONFIG });
      }
    }

    private formatCoins(n?: number | null): string {
      if (n == null || isNaN(n as number)) return '—';
      return n.toLocaleString('pt-BR');
    }

    /** Normaliza string → número inteiro, respeitando min/max */
    private clampToRange(raw: string, minAttr?: string | number | null, maxAttr?: string | number | null, allowNegative = false): string {
      // remove tudo que não é dígito (e opcionalmente o sinal "-")
      const cleaned = (raw || '').replace(allowNegative ? /[^0-9-]/g : /[^0-9]/g, '');

      if (cleaned === '' || cleaned === '-') return ''; // deixa vazio se o usuário ainda está digitando

      let n = parseInt(cleaned, 10);
      if (!Number.isFinite(n)) return '';

      const min = (minAttr !== undefined && minAttr !== null && minAttr !== '') ? Number(minAttr) : undefined;
      const max = (maxAttr !== undefined && maxAttr !== null && maxAttr !== '') ? Number(maxAttr) : undefined;

      if (typeof min === 'number' && Number.isFinite(min) && n < min) n = min;
      if (typeof max === 'number' && Number.isFinite(max) && n > max) n = max;

      return String(n);
    }

    /** Bloqueia teclas inválidas e garante min/max em tempo real para inputs number */
    private setupNumericValidation(): void {
      const $scope = $('#config-dme'); // limite à área das configs; troque se quiser abranger a página toda

      // 1) Bloqueio de teclas inválidas (keydown)
      $scope.on('keydown', 'input[type="number"]', (ev: any) => {
        const e = ev as any as KeyboardEvent;
        const key = e.key;

        // atalhos e teclas de navegação
        const ctrlCmd = e.ctrlKey || e.metaKey;
        const allowedNav: any = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (allowedNav.includes(key) || (ctrlCmd && (['a', 'c', 'v', 'x', 'z', 'A', 'C', 'V', 'X', 'Z'] as any).includes(key))) return;

        const target = ev.currentTarget as HTMLInputElement;
        const minAttr = target.getAttribute('min');
        const allowNegative = !!(minAttr && Number(minAttr) < 0);

        // Só dígitos; SEM ".", "e", "E", "+"; "-" apenas se min < 0 e no início
        if (key >= '0' && key <= '9') return;
        if (key === '-' && allowNegative) {
          // permitir "-" apenas na posição 0 e se ainda não existe
          const hasMinus = target.value.includes('-');
          const caretAtStart = (target.selectionStart != null ? target.selectionStart : 0) === 0;
          if (!hasMinus && caretAtStart) return;
        }

        // bloqueia qualquer outra tecla
        e.preventDefault();
      });

      // 2) Sanitização em paste (colar)
      $scope.on('paste', 'input[type="number"]', (ev: any) => {
        const e = ev.originalEvent as ClipboardEvent;
        const t = ev.currentTarget as HTMLInputElement;
        if (!e || !e.clipboardData) return;
        const pasted = e.clipboardData.getData('text') || '';

        const allowNegative = !!(t.getAttribute('min') && Number(t.getAttribute('min')) < 0);
        const minAttr = t.getAttribute('min');
        const maxAttr = t.getAttribute('max');

        const next = this.clampToRange(pasted, minAttr, maxAttr, allowNegative);
        e.preventDefault();
        t.value = next;
        // dispara change para sua persistência
        $(t).trigger('change');
      });

      // 3) Sanitização contínua (input) e clamp em min/max
      $scope.on('input', 'input[type="number"]', (ev: any) => {
        const t = ev.currentTarget as HTMLInputElement;
        const allowNegative = !!(t.getAttribute('min') && Number(t.getAttribute('min')) < 0);
        const minAttr = t.getAttribute('min');
        const maxAttr = t.getAttribute('max');

        const next = this.clampToRange(t.value, minAttr, maxAttr, allowNegative);
        if (t.value !== next) {
          t.value = next;
          $(t).trigger('change');
        }
      });

      // 4) Ajuste final ao sair do campo (blur) — evita ficar vazio quando min > 0
      $scope.on('blur', 'input[type="number"]', (ev: any) => {
        const t = ev.currentTarget as HTMLInputElement;
        const minAttr = t.getAttribute('min');
        if ((t.value === '' || t.value === '-') && minAttr !== null && minAttr !== '') {
          t.value = String(Number(minAttr));
          $(t).trigger('change');
        }
      });

      // 5) (Opcional) Impede rolagem do mouse alterar números sem querer
      $scope.on('wheel', 'input[type="number"]', (ev) => {
        (ev.currentTarget as HTMLInputElement).blur();
      });
    }


    /**
     * Monta um resumo descritivo para log.
     */
    // ...existing code...
    private criarResumoDescritivo(resp: IResultadoSolucaoDME) {
      // ...existing code...
      const compras = (resp.jogadoresComprados !== undefined && resp.jogadoresComprados !== null)
        ? resp.jogadoresComprados
        : [];
      // ...existing code...

      // 1) Total gasto no DME (somando todos desafios)
      const totalGasto = compras.reduce(function (acc, c) { return acc + (Number(c.preco) || 0); }, 0);

      // 2) Top 2 itens de recompensa por preço desc, desempate por rating desc
      var itensRecompensa = resp.itensRecompensa != null ? resp.itensRecompensa : [];
      var recompensasPlanas: ItemRecompensaBase[] = [];
      for (var i = 0; i < itensRecompensa.length; i++) {
        var bloco = itensRecompensa[i];
        var items = bloco && bloco.items ? bloco.items : [];
        for (var j = 0; j < items.length; j++) {
          var item = items[j];
          if (item.itemType != "player") continue; // só jogadores
          recompensasPlanas.push(item);
        }
      }
      const recompensasOrdenadas = recompensasPlanas
        .map(function (item) {
          return {
            assetId: item && item.assetId,
            rating: Number(item && item.rating) || 0,
            preco: item.untradeable ? 0 : (item && item.price != null ? item.price : (item && item.futggprice ? item.futggprice.price : 0)),
            name: ''
          };
        })
        .sort(function (a, b) {
          return (b.preco - a.preco) || (b.rating - a.rating);
        });

      const top2 = recompensasOrdenadas.slice(0, 2);

      // 3) Recompensas: soma preços quando disponível (price ou futggprice.price)
      var somaRecompensas = 0;
      var temAlgumPreco = false;
      var qtdRecompensas = itensRecompensa.length;
      for (var i = 0; i < recompensasPlanas.length; i++) {
        var item: ItemRecompensaBase = recompensasPlanas[i];
        var price = item.untradeable ? 0 : (item && item.price != null ? item.price : (item && item.futggprice ? item.futggprice.price : undefined));
        if (typeof price === 'number' && !isNaN(price)) {
          somaRecompensas += price;
          temAlgumPreco = true;
        }
      }

      const totalRecompensasEstimado = temAlgumPreco ? somaRecompensas - totalGasto : null;

      // 4) Objeto final “descritivo”
      const resumo = {
        id: resp.id,
        name: resp.name,
        completo: !!resp.completo,
        progresso:
          String((resp.desafiosConcluidos != null ? resp.desafiosConcluidos : 0)) +
          "/" +
          String((resp.totalDesafios != null ? resp.totalDesafios : 0)),
        totalGasto: totalGasto, // em coins
        recompensas: {
          quantidade: qtdRecompensas,
          totalEstimado: totalRecompensasEstimado // null quando não há preço disponível
        },
        top2Recompensas: top2.map(function (r) {
          return {
            assetId: r.assetId,
            rating: r.rating,
            preco: r.preco,
            name: r.name
          };
        }),
        // string pronta pra log/alert
        descricao: (() => {
          const concluidos = `${resp.desafiosConcluidos != null ? resp.desafiosConcluidos : 0}/${resp.totalDesafios != null ? resp.totalDesafios : 0}`;
          const recompensaStr = temAlgumPreco ? "<b>" + (this.formatCoins(totalRecompensasEstimado) + " coins</b>") : "—<br/>";

          const topStrs = top2.map((item, idx) => {
            if (!item) return "—<br/>";
            var player = App.Util.getItemArrayById(App.SniperExtensao.players, item.assetId, App.SniperExtensao.objJogadorDefault);
            var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);

            const nome = nomeJogador ? nomeJogador : (item.name ? item.name : `#${item.assetId}`);
            return `<b>${nome} (${item.rating})</b>: <b>${this.formatCoins(item.preco)} coins</b>`;
          });

          // Garante sempre 2 linhas para o top2
          while (topStrs.length < 2) topStrs.push("");

          return (
            '------------------<br/><b>🎯DME: "' + resp.name + '"</b>:<br/>' +
            '<b>•</b> Desafios concluídos/total: <b>' + concluidos + '</b><br/>' +
            '<b>•</b> Gasto Total: <b>' + this.formatCoins(totalGasto) + ' coins</b> <br/>' +
            '<b>•</b> Lucro Previsto: ' + recompensaStr + ' <br/>' +
            '<b>•</b> Top Recompensa: ' + topStrs[0] + '<br/> ' + topStrs[1]
          );
        })()
      };

      return resumo;
    }

    public cancelarSolucao() {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "cancslcao" }, (resposta: any) => { });
      toastr.warning("O Auto DME será interrompido, Aguarde...", "Interrompendo!");
      setTimeout(() => {
        App.SniperExtensao.ocultarLoadingSniperApp()
      }, 5000);
    }

    private scanearClube(): void {
      try {
        chrome.runtime.sendMessage(this.idExtensao, { evento: "scnnerclb" }, (_resultado: any) => { });
      } catch (e) {
        console.error('Falha ao enviar mensagem à extensão:', e);
      }
    }

    private getLogJogadoresAberturaPacotes(playersPackPrices: IPlayerResumo[]): any {
      try {
        console.log("playersPackPrices", playersPackPrices)
        playersPackPrices.sort((a, b) => (b.preco || 0) - (a.preco || 0));
        const lucroPrevisto = playersPackPrices.reduce((total, item) => {
          const preco = typeof item.preco === 'number' && !item.untradeable ? item.preco : 0;
          return total + preco;
        }, 0);

        return `Jogadores recebidos de pacote. <b>Lucro Previsto: ${lucroPrevisto}</b>
        <br />${playersPackPrices.map(obj => `<b>${obj.name}(${obj.rating})</b> por <b>${obj.preco}</b>`).join(", ")}`;
      } catch (e) {
        console.log("erro log pacote", e)
        return ``;
      }
    }

    public processarMensagensAutoDme(request: { evento: string, dados: any }) {
      console.log("📫 MSG AUTO DME", request);
      switch (request.evento) {
        case 'atualizar_dmes': {
          const dmes = request.dados as IDmes;
          console.log("atualizar_dmes", dmes);
          this.categoriaDmes = dmes.categories || [];
          // salva último conjunto de DMEs carregados
          this.writeLastDmes(this.categoriaDmes);
          // repopula selects e restaura seleção se possível
          this.populateCategorySelect();
          break;
        }
        case 'dme_nao_encontrado': {
          App.SniperExtensao.ocultarLoadingSniperApp()
          console.log("dme_nao_encontrado");
          this.exibirLog("danger", "Não encontrado", "Dme já foi resolvido ou não existe mais.");
          break;
        }
        case 'dme_executado': {
          App.SniperExtensao.ocultarLoadingSniperApp()
          const dadosDmeResposta = request.dados as IResultadoSolucaoDME;
          console.log("dme_executado", dadosDmeResposta.completo);
          const resumo = this.criarResumoDescritivo(dadosDmeResposta);
          if (dadosDmeResposta.completo) {
            this.exibirLog("success", "Pronto!", `Seu DME foi resolvido.<br/> ${resumo.descricao}`);
          } else {
            const sugestao = '------------------<br/><b>Sugestões:</b><br/>' +
              '<b>•</b> Ajuste as config Min/Max rating de jogadores e preço Max de DME e Jogadores;<br/>' +
              '<b>•</b> Use Sugestão com solução externa(Recomendado);<br/>' +
              '<b>•</b> A Sugestão com solução interna é mais rápida e eficaz em alguns casos;<br/>' +
              '<b>•</b> Aumente a quantidade de soluções externas;<br/>' +
              '<b>•</b> Deixe a quantidade 0 em "Jog. conceito qtd. máx";<br/>' + ''
            '<b>•</b> Verifique os requisitos do DME e reconfigure de acordo;<br/>' + ''
            '<b>•</b> Se ainda não resolver use a sugestão: "Buscar solução Externa sem informar jogadores clube";<br/>'
            '<b>•</b> Esse é um recurso Beta, por enquanto <b>nem todos os DMEs podem ser resolvidos</b>";<br/>' + ''

            this.exibirLog("info badge-alerta-amarelo", "Incompleto!", `Não foi possível completar o DME. Tente novamente ajustando as configurações. Alguns desafios podem ter sido solucionados parcialmente utilizando jogadores de conceito.<br/>  ${resumo.descricao}<br/> ${sugestao}`);
          }
          break;
        }
        case 'coletando_jog_externo': {
          this.exibirLog("info", "Coletando!", "Coletando jogadores de soluções externas e preparando jogadores de conceitos.");
          break;
        }
        case 'preparado_jog_conceitos': {
          this.exibirLog("info", "Conceito!", "Preparado com jogadores de conceito.");
          break;
        }
        case 'pack': {
          const dadosDmeResposta = request.dados as { status: boolean, acao: number, playersPackPrices: IPlayerResumo[] };
          switch (dadosDmeResposta.acao) {
            case 0:
              this.exibirLog("info", "Abrindo Pacote Ineg.!", `Abrindo os pacotes de recompensa <b>inegociáveis</b>, aguarde...`);
              break;
            case 1:
              this.exibirLog("info", "Abrindo Pacote Neg.!", `Abrindo os pacotes de recompensa <b>negociáveis</b>, aguarde...`);
              break;
            // case 2:
            //   this.exibirLog("info", "Analisando Pacote!", `Analisando pacote aberto...`);
            //   break;
            // case 3:
            //   this.exibirLog("success", "Pacote Analisado!", `Itens do pacote foram processados com sucesso.`);
            //   break;
            case 4:
              App.SniperExtensao.ocultarLoadingSniperApp()
              this.exibirLog("danger", "Resgate Necessário!", `É importante resgatar os itens de escolha manualmente.`);
              break;
            case 5:
              App.SniperExtensao.ocultarLoadingSniperApp()
              this.exibirLog("success badge-pacote-aberto", "Pacote Aberto!", this.getLogJogadoresAberturaPacotes(dadosDmeResposta.playersPackPrices));
              break;
          }
          break;
        }
        case 'auto_resolvedor': {
          App.SniperExtensao.exibirLoadingSniperApp('<i class="fas " style="font-size: 34px;" title="Resolvendo aguarde...">🕔</i>', false, "Resolvendo aguarde...");
          const dadosDmeResposta = request.dados as {
            status: boolean, acao: number, msg: string, link: string, statusCode: number, playersCount: number, nome: string, desafio: string, quantidadeJogadores: number, configPrecoMaxJogador: number,
            somaDoPrecoDeCompraTodosJogadores?: number, jogador: IItemListagem, quantidadeJogadoresComprados: number, quantidadePacksresgatados: number,
            tentativa: number
          };
          switch (dadosDmeResposta.acao) {
            case 0:
              this.exibirLog("info", "Iniciando Desafio!", `DME <b>${dadosDmeResposta.nome}</b> sendo solucionado, aguarde...`);
              break;
            case 1:
              this.exibirLog("info", "Buscando Solução!", `Buscando uma solução para o desafio <b>${dadosDmeResposta.nome}</b> usando <b>${dadosDmeResposta.quantidadeJogadores}</b> jogadores.`);
              break;
            case 2:
              if (dadosDmeResposta.status) {
                this.exibirLog("success", "Possível Solução!", `Uma possível solução foi encontrada para o desafio <b>${dadosDmeResposta.nome}</b>.`);
              } else {
                this.exibirLog("info badge-alerta-amarelo", "Sem Solução!", `Não foi possível encontrar uma solução para o desafio <b>${dadosDmeResposta.nome}</b>.`);
              }
              break;
            case 3:
              this.exibirLog("info", "Requisito!", `Necessário comprar <b>${dadosDmeResposta.quantidadeJogadores} jogadores</b> para concluir o desafio.`);
              break;
            case 4:
              this.exibirLog("info", "Buscando!", `Buscando e identificando os preços dos jogadores na EA, aguarde...`);
              break;
            case 5:
              this.exibirLog("info", "Total Estimado!", `O preço estimado para comprar todos os jogadores é de <b>${dadosDmeResposta.somaDoPrecoDeCompraTodosJogadores} coins</b>.`);
              break;
            case 6:
              this.exibirLog("info badge-alerta-amarelo", "Compra Inviável!", `O Sistema só irá comprar quando tiver certeza<b>(Configuração:Comprar só c/ certeza)</b> que a solução será concluída, ou seja, todos os jogadores tem que estar no <b>orcamento(Configurado)</b> e disponíveis no mercado.`);
              break;
            case 7:
              this.exibirLog("info badge-alerta-amarelo", "Compra Inviável!", `O Sistema  irá comprar os jogadores, mesmo não tendo certeza que a solução será concluída <b>(Configuração:Comprar só c/ certeza DESATIVADA)</b>.`);
              break;
            case 8:
              this.exibirLog("info", "Comprando!", `O Sistema iniciou as compras dos jogadores, aguarde...`);
              break;
            case 9:
              this.exibirLog("info badge-alerta-amarelo", "Comprou!", `Comprou jogador <b>${dadosDmeResposta.jogador.name}(${dadosDmeResposta.jogador.rating})</b> por <b>${dadosDmeResposta.jogador.buyNowPrice} coins</b>.`);
              break;
            case 10:
              this.exibirLog("info", "Compras Finalizadas!", `Foram comprados <b>${dadosDmeResposta.quantidadeJogadoresComprados} jogadores</b> para o desafio <b>${dadosDmeResposta.nome}</b>.`);
              break;
            case 11:
              this.exibirLog("success", "Desafio Enviado!", `Desafio <b>${dadosDmeResposta.nome}</b> enviado.`);
              break;
            case 12:
              this.exibirLog("success", "Packs Resgatados!", `Foram resgatados <b>${dadosDmeResposta.quantidadePacksresgatados} packs</b> do desafio <b>${dadosDmeResposta.nome}</b>.`);
              break;
            case 13:
              this.exibirLog("info badge-alerta-amarelo", "Jogador caro!", `O Jogador <b>${dadosDmeResposta.jogador.name}(${dadosDmeResposta.jogador.rating})</b>
                está com preço de <b>${dadosDmeResposta.jogador.buyNowPrice} coins</b> acima do valor máximo configurado de <b>${dadosDmeResposta.configPrecoMaxJogador} coins</b>
                para compra, portanto não será comprado e foi adicionado a lista de ignorados para um nova tentativa de solução.`);
              break;
            case 14:
              this.exibirLog("danger", "Sem Mercado!", `Não é possível comprar jogadores para o DME, pois o mercado está inacessível para essa conta.`);
              break;
            case 15:
              this.exibirLog("info badge-alerta-amarelo", "Sem Saldo!", `Não é possível comprar jogadores para o DME, pois a conta não possui coins suficientes.`);
              break;
            case 16:
              if (dadosDmeResposta.hasOwnProperty('playersCount') && dadosDmeResposta.playersCount <= 0) {
                this.exibirLog("danger", "Faltou Jogadores!", `Não foi possível encontrar jogador viável para o DME, tente novamente ajustando as configurações.`);
                break;
              }

              if (dadosDmeResposta.hasOwnProperty('msg') && dadosDmeResposta.hasOwnProperty('statusCode') && ([401, 403, 500] as any).includes(dadosDmeResposta.statusCode) && (dadosDmeResposta.msg == "compra" || dadosDmeResposta.msg == "busca")) {
                this.exibirLog("danger", "Falha de Autenticacao!", `Verifique se sua conta não está sendo logada em outro dispositivo/navegador/aba, isso pode impedir o auto Dme de funcionar corretamente.`);
                break;
              }

              this.exibirLog("danger", "erro!", `Um erro desconhecido ocorreu [${dadosDmeResposta.msg}], se o problema continuar, avise o desenvolvedor mandando e-mail para contato@futsniperweb.com.br.`);
              break;
            case 17:
              this.exibirLog("danger", "Interrompido!", `O Auto Dme foi interrompido.`);
              break;
            case 18:
              this.exibirLog("info badge-alerta-amarelo", "Jogador Extinto!", `Não foi possível encontrar o jogador <b>${dadosDmeResposta.jogador.name}(${dadosDmeResposta.jogador.rating})</b>.`);
              break;
            case 19:
              this.exibirLog("primary", "Solução Rápida!", `A Solução rápida será usada para o DME <b>${dadosDmeResposta.nome}</b>, essa solução tem como modelo a busca de soluções externa online sem se preocupar com jogadores atualmente no seu clube.`);
              break;
            case 20:
              let linkUsado = dadosDmeResposta.link ? `<br/>Link usado: <a href="${dadosDmeResposta.link}" target="_blank">${dadosDmeResposta.link}</a>` : "";
              this.exibirLog("primary", "Analisando Solução Externa!", ` Analisando solução externa <b>№${dadosDmeResposta.tentativa}</b> online encontrada para o DME <b>${dadosDmeResposta.nome}</b>.${linkUsado} `);
              break;
            case 21:
              this.exibirLog("success", "Solucionado!", `O Desafio <b>${dadosDmeResposta.nome}</b> foi solucionado.`);
              break;
            case 22:
              this.exibirLog("info badge-alerta-amarelo", "Desafio Incompatível!", `O Desafio <b>${dadosDmeResposta.desafio}</b> é um desafio que a inteligência do sistema interno ainda não consegue solucionar, mas é possível que se resolva usando a opção:<b>"solução rápida"</b>.`);
              break;
            case 23:
              this.exibirLog("info badge-alerta-amarelo", "Rating Ajustado!", `O sistema precisou de jogadores com exigência de rating diferente da configuração atual, portanto, <b>foi necessário um ajuste no Min/Max Rating</b>.`);
              break;
            case 24:
              this.exibirLog("info badge-alerta-amarelo", "Compra Incompleta!", `O sistema não conseguiu comprar todos os jogadores para o desafio <b>${dadosDmeResposta.desafio}</b>. A solução encontrada foi salva, mas alguns jogadores ainda precisam ser adquiridos manualmente. Verifique quais estão faltando e realize a compra manualmente para completar o DME.`
              );
              break;
            case 25:
              this.exibirLog("info badge-alerta-amarelo", "Desafio não resolvido!", `O sistema não conseguiu resolver o desafio <b>${dadosDmeResposta.desafio}</b>. se utilizou links externos, verifique se o link possui uma solução correta.`
              );
              break;
            case 26:
              this.exibirLog("info badge-alerta-amarelo", "Sobra de Jogadores!", `Jogadores comprados mas não usados no dme, serão enviados para a lista de transferência.`
              );
              break;
          }
          break;
        }
        case 'teste': {
          break;
        }
      }
    }
  }
}
